import { render, staticRenderFns } from "./page16.vue?vue&type=template&id=79ff7ace&scoped=true&"
import script from "./page16.vue?vue&type=script&lang=js&"
export * from "./page16.vue?vue&type=script&lang=js&"
import style0 from "./page16.vue?vue&type=style&index=0&id=79ff7ace&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ff7ace",
  null
  
)

export default component.exports